import { render, staticRenderFns } from "./EscalaSilverman.vue?vue&type=template&id=1460a660&"
import script from "./EscalaSilverman.vue?vue&type=script&lang=js&"
export * from "./EscalaSilverman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports